const quotes = [
  {
    id: "sasha",
    name: "Sasha Joseph",
    quote:
      "Taylor is a polymath who has it all—smarts, business savvy, and an inimitable ability to blend artistic vision with the technical work of building digital products.",
    title: "Senior Engineer, Netflix",
    link: "https://www.linkedin.com/in/sashajoseph/"
  },
  {
    id: "zack",
    name: "Zack Brown",
    quote:
      "Taylor is a bona fide unicorn: a top-tier product designer and a talented UI developer. He has impressed me with his problem-solving mindset, his level head, and his ability to leave ego at the door when collaborating over complex and nuanced problems.",
    title: "Co-Founder, Pax Lang",
    link: "https://twitter.com/zackaboo"
  },
  {
    id: "matthew",
    name: "Matthew Trost",
    quote:
      "Taylor brings that rare combination of talents that are essential to have on a product team: design intuition, technical know-how, and empathy for the user. From planning to prototyping to launch, he was instrumental in bringing our product to market.",
    title: "Co-founder, Engineer, Aesthetic",
    link: "https://www.linkedin.com/in/matthew-trost-8081a342/"
  },
  {
    id: "daniel",
    name: "Daniel R. Buscaglia",
    quote:
      "From our first collaboration together, it became immediately clear that Taylor is a world-class product design talent. He was entirely motivating, inspiring, and fun to work with.",
    title: "Senior Engineer, Rippling",
    link: "https://www.linkedin.com/in/daniel-r-buscaglia-668a1b1/"
  }
];

export default quotes;
